export const UNLIMITED = -1

// 充值消耗套餐可选的渠道，mintegral，unity，applovin
export const rechargeTypeChannels = [21, 5, 7]

export enum ChangeKeys {
  Online = 'online',
  DownloadPush = 'download_push',
  RenderVideo = 'render_video',
  AigcCredits = 'aigc_credits',
  Storage = 'storage',
  VoiceClone = 'voice_clone',
  VideoCredits = 'video_credits',
  UnitPrice = 'unit_price',
}
